import __request__ from 'routing/request';
interface O365SubscriptionRequest {
    readonly o365_endpoint: 'ENTERPRISE' | 'GCC_HIGH' | 'DOD';
    readonly o365_general_records: boolean;
    readonly o365_dlpall_records: boolean;
    readonly o365_exchange_records: boolean;
    readonly o365_sharepoint_records: boolean;
    readonly o365_client_id: string;
    readonly o365_azuread_records: boolean;
    readonly o365_tenant_id: string;
    readonly o365_client_secret: unknown;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface O365CreateInputRequest {
    readonly endpoint_type: 'ENTERPRISE' | 'GCC_HIGH' | 'DOD';
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly drop_sensitive_info_logs: boolean;
    readonly name: string;
    readonly content_types: string[];
    readonly o365_client_id: string;
    readonly o365_tenant_id: string;
    readonly store_full_message: boolean;
    readonly polling_interval: number;
    readonly enable_throttling: boolean;
    readonly o365_client_secret: unknown;
}
interface O365RequestImpl {
    readonly o365_endpoint: 'ENTERPRISE' | 'GCC_HIGH' | 'DOD';
    readonly o365_client_id: string;
    readonly o365_tenant_id: string;
    readonly o365_client_secret: unknown;
}
/**
 * Check available subscriptions
 */
export function checkSubscriptions(JSONbody: O365RequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.office365.api.O365Resource/office365/checkSubscriptions', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new O365 input
 */
export function create(JSONbody: O365CreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.office365.api.O365Resource/office365/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
/**
 * Start selected subscriptions
 */
export function startSubscription(JSONbody: O365SubscriptionRequest): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.office365.api.O365Resource/office365/startSubscription', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
